/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Notification } from '../models';
// @ts-ignore
import type { ResponseCountNewNotifications } from '../models';
/**
 * NotificationApi - axios parameter creator
 * @export
 */
export const NotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary All notifications
         * @param {AllNotificationsCategoryEnum} category 
         * @param {boolean} [onlyNew] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allNotifications: async (category: AllNotificationsCategoryEnum, onlyNew?: boolean, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('allNotifications', 'category', category)
            const localVarPath = `/notification/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (onlyNew !== undefined) {
                localVarQueryParameter['onlyNew'] = onlyNew;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Count new notification
         * @param {CountNewNotificationCategoryEnum} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countNewNotification: async (category: CountNewNotificationCategoryEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('countNewNotification', 'category', category)
            const localVarPath = `/notification/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read notification
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readNotification: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('readNotification', 'id', id)
            const localVarPath = `/notification/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationApi - functional programming interface
 * @export
 */
export const NotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary All notifications
         * @param {AllNotificationsCategoryEnum} category 
         * @param {boolean} [onlyNew] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allNotifications(category: AllNotificationsCategoryEnum, onlyNew?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Notification>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allNotifications(category, onlyNew, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.allNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Count new notification
         * @param {CountNewNotificationCategoryEnum} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countNewNotification(category: CountNewNotificationCategoryEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCountNewNotifications>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countNewNotification(category, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.countNewNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read notification
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readNotification(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Notification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readNotification(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.readNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationApi - factory interface
 * @export
 */
export const NotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationApiFp(configuration)
    return {
        /**
         * 
         * @summary All notifications
         * @param {AllNotificationsCategoryEnum} category 
         * @param {boolean} [onlyNew] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allNotifications(category: AllNotificationsCategoryEnum, onlyNew?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Notification>> {
            return localVarFp.allNotifications(category, onlyNew, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Count new notification
         * @param {CountNewNotificationCategoryEnum} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countNewNotification(category: CountNewNotificationCategoryEnum, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCountNewNotifications> {
            return localVarFp.countNewNotification(category, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read notification
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readNotification(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Notification> {
            return localVarFp.readNotification(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationApi - interface
 * @export
 * @interface NotificationApi
 */
export interface NotificationApiInterface {
    /**
     * 
     * @summary All notifications
     * @param {AllNotificationsCategoryEnum} category 
     * @param {boolean} [onlyNew] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApiInterface
     */
    allNotifications(category: AllNotificationsCategoryEnum, onlyNew?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Notification>>;

    /**
     * 
     * @summary Count new notification
     * @param {CountNewNotificationCategoryEnum} category 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApiInterface
     */
    countNewNotification(category: CountNewNotificationCategoryEnum, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCountNewNotifications>;

    /**
     * 
     * @summary Read notification
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApiInterface
     */
    readNotification(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Notification>;

}

/**
 * NotificationApi - object-oriented interface
 * @export
 * @class NotificationApi
 * @extends {BaseAPI}
 */
export class NotificationApi extends BaseAPI implements NotificationApiInterface {
    /**
     * 
     * @summary All notifications
     * @param {AllNotificationsCategoryEnum} category 
     * @param {boolean} [onlyNew] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public allNotifications(category: AllNotificationsCategoryEnum, onlyNew?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).allNotifications(category, onlyNew, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Count new notification
     * @param {CountNewNotificationCategoryEnum} category 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public countNewNotification(category: CountNewNotificationCategoryEnum, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).countNewNotification(category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read notification
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public readNotification(id: number, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).readNotification(id, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AllNotificationsCategoryEnum = {
    Admin: 'admin',
    Caf: 'caf',
    Citizen: 'citizen'
} as const;
export type AllNotificationsCategoryEnum = typeof AllNotificationsCategoryEnum[keyof typeof AllNotificationsCategoryEnum];
/**
 * @export
 */
export const CountNewNotificationCategoryEnum = {
    Admin: 'admin',
    Caf: 'caf',
    Citizen: 'citizen'
} as const;
export type CountNewNotificationCategoryEnum = typeof CountNewNotificationCategoryEnum[keyof typeof CountNewNotificationCategoryEnum];
